import { useEffect } from "react";

export function useBuildVersionCheck() {
  useEffect(() => {
    const currentVersion = localStorage.getItem("app_version");
    const metaTag = document.querySelector("meta[name='app-version']");
    const newVersion = metaTag?.getAttribute("content");

    if (newVersion) {
      if (currentVersion && currentVersion !== newVersion) {
        console.log("🔄 New version detected. Reloading...");
        localStorage.setItem("app_version", newVersion);
        window.location.reload();
      } else if (!currentVersion) {
        localStorage.setItem("app_version", newVersion);
      }
    }
  }, []);
}
